import type { ISubmeterFilters, ISubmeterReportFilters } from '@/types/eos/filters'
import type { ISubmeter } from '@/types/eos/Submeters'
import type { IPage } from '@/types/shared/pagination'
import { downloadFile } from '@/util'
import axios from 'axios'

export async function getSubmeters(filters: ISubmeterFilters): Promise<IPage<ISubmeter>> {
  const res = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/submeters`, {
    params: filters,
  })
  return res.data
}

export const getSubmeterReport = async (filters: ISubmeterReportFilters): Promise<any> => {
  const res = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/submeters/reports`, {
    params: filters,
    responseType: 'arraybuffer',
  })

  const fileExtension = 'xlsx' // Default to xlsx
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  const filename = `${filters.device_name}_${filters.year}-${filters.month}.${fileExtension}`

  const file = new Blob([res.data], { type: fileType })
  downloadFile(file, filename)
}
